import { EmployeeInfo } from '../../../../models';

export const ACTIONS = {
  SALES_CHANNEL: 'SALES_CHANNEL',
  REGION: 'REGION',
  SUBREGION: 'SUBREGION',
  RELATIONSHIP: 'RELATIONSHIP',
  DNI: 'DNI',
  ROLE: 'ROLE',
  DEFAULT: 'DEFAULT',
} as const;

export type ACTIONS_TYPE =
  | { type: 'SALES_CHANNEL'; payload: string }
  | { type: 'REGION'; payload: string }
  | { type: 'SUBREGION'; payload: string }
  | { type: 'RELATIONSHIP'; payload: string }
  | { type: 'ROLE'; payload: string }
  | { type: 'DEFAULT'; payload: Partial<EmployeeInfo> };

export function reducer(
  state: Partial<EmployeeInfo>,
  action: ACTIONS_TYPE
): Partial<EmployeeInfo> {
  switch (action.type) {
    case ACTIONS.SALES_CHANNEL:
      return { ...state, salesChannel: action.payload };
    case ACTIONS.REGION:
      return { ...state, region: action.payload };
    case ACTIONS.SUBREGION:
      return { ...state, subRegion: action.payload };
    case ACTIONS.RELATIONSHIP:
      return { ...state, relationship: action.payload };
    case ACTIONS.ROLE:
      return { ...state, role: action.payload };
    case ACTIONS.DEFAULT:
      return { ...state, ...(action?.payload ?? {}) };
    default:
      return { ...state };
  }
}
